export enum LeadBannerGoal {
  Impression = 'assistantSalesCardImpression',
  SheetOpen = 'assistantSalesSheetOpen',
  FormStart = 'assistantSalesFormStart',
  FormSubmit = 'assistantSalesFormSubmit',
}

export enum LeadBannerPlacement {
  Serp = 'serp',
  MainPage = 'main_page',
}

export enum LeadBannerTriggerReason {
  Default = 'default',
  EmptySerp = 'empty_serp',
  ShortSerp = 'short_serp',
  AlternativeSerp = 'alternative_serp',
}

export interface LeadBannerTrackingContext {
  key: string;
  placement: LeadBannerPlacement;
  position: number | null;
  triggerReason: LeadBannerTriggerReason;
}

export type LeadBannerViewGoalParams = {
  placement: LeadBannerPlacement;
  card_id: string;
  position: number | null;
  trigger_reason: LeadBannerTriggerReason;
};

export type LeadBannerFormGoalParams = Omit<LeadBannerViewGoalParams, 'position'>;

export type LeadBannerGoalParams = LeadBannerViewGoalParams | LeadBannerFormGoalParams;
